// src/components/SimpleComponents/SimpleEntityProfiles.jsx
// *******************************************************************************
// SIMPLE ENTITY PROFILES
// *******************************************************************************
// Multi-select component for entity profiles (customer, provider, company, etc.)
// Wraps SimpleSelect with pre-configured options and validation.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleSelect from './SimpleSelect';
import { ENTITY_PROFILE_OPTIONS } from 'constants/EntityConstants';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleEntityProfiles = ({
  name = 'entityProfile',
  subdocumentField,
  label = 'entity_profile',
  placeholder = 'select_profiles',
  options = ENTITY_PROFILE_OPTIONS.filter(x => x.basic),
  maxTagCount = 2,
  required = true,
  disabled = false,
  onChange,
  style = {},
  styleItem = {},
  ...props
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SimpleSelect
      name={name}
      subdocumentField={subdocumentField}
      label={label}
      placeholder={placeholder}
      options={options}
      mode="multiple"
      maxTagCount={maxTagCount}
      maxTagPlaceholder={omittedValues => `+${omittedValues.length}`}
      style={{ width: '100%', ...style }}
      styleItem={styleItem}
      onChange={onChange}
      allowClear={false}
      showSearch={false}
      required={required}
      disabled={disabled}
      {...props}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleEntityProfiles;
